import { TFunction } from 'i18next';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath, APIPathWithArguments } from 'src/js/api/route-path-index';
import { notificationHandler } from 'src/js/notification/notification-handler';
import { createWatchStore, updateWatchStore } from 'src/js/store/use-watch';
import { AssetModel, GetAssetsResponse } from './assets-models';

const assetsStore: AssetModel[] = [];
createWatchStore(assetsStore);
export { assetsStore };

export const fetchAssets = (_t: TFunction) => {
  return apiClientWithoutHandler.genericController.get<GetAssetsResponse>(APIPath.assets.all).then((res) => {
    if (res.ok) {
      const response = res.data;
      if (response) {
        // here catch all updates from status "Active" => "Completed", if so put the timestamp of when it was updated
        assetsStore.map((asset) => {
          if (asset.status === 'Active') {
            const newModel = response.data.find((n) => n.id === asset.id);
            // console.log('newModel',asset, newModel)
            if (newModel?.status === 'Completed') {
              newModel.completedTimestamp = new Date().getTime();
            }
          }
        });
        updateWatchStore(assetsStore, response.data);
      }
    }
    return res;
  });
};

export const deleteAsset = (model: Partial<AssetModel>, t: TFunction) => {
  let path = APIPathWithArguments(APIPath.assets.delete, { id: model.name });
  if (model.parent) {
    path = APIPathWithArguments(APIPath.assets.deleteSegment, { id: model.name, parent: model.parent.id });
  }
  return apiClientWithoutHandler.genericController.delete(path).then((res) => {
    if (!res.ok) {
      notificationHandler(
        res,
        t('assets.notifications.deleteSuccessMsg', { name: model.name }),
        t('assets.notifications.deleteErrorMsg', { name: model.name }),
        t,
      );
    }
    return {
      ...res,
      itemsCount: model.segmented ? model.segments.length : 1,
    };
  });
};
